import { useEffect, useState } from 'react'

import { APP_VERSION } from '@/configs/version'

interface VersionInfo {
  buildTime: number
  version: string
  timestamp: number
}

const POLLING_INTERVAL = 60000

export function useHotUpdateDetector() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false)
  const [lastChecked, setLastChecked] = useState<number | null>(null)
  const [lastVersion, setLastVersion] = useState<string | undefined>(APP_VERSION)

  useEffect(() => {
    let isSubscribed = true
    const currentVersion = APP_VERSION
    const checkVersion = async () => {
      if (!isSubscribed) return

      if (import.meta.hot) {
        import.meta.hot.on('vite:beforeUpdate', () => {
          // console.log('🔥 Vite is updating...')
          // setNewVersionAvailable(true)
        })
        return
      }

      try {
        setLastChecked(Date.now())

        const response = await fetch(`/version.json?t=${Date.now()}`)
        if (!response.ok) {
          console.error('Failed to fetch version info!')
        }

        const data: VersionInfo = await response.json()
        if (data.version !== currentVersion) {
          setNewVersionAvailable(true)
          setLastVersion(data.version)
        }
      } catch (error) {
        console.error('❌ Failed to check version: ', error)
      }
    }

    checkVersion()
    const interval = setInterval(checkVersion, POLLING_INTERVAL)

    return () => {
      isSubscribed = false
      clearInterval(interval)
    }
  }, [])

  const onClose = () => {
    setNewVersionAvailable(false)
  }

  return {
    newVersionAvailable,
    refreshPage: () => window.location.reload(),
    lastChecked,
    lastVersion,
    setNewVersionAvailable,
    onClose,
  }
}
